import React, { Component, createRef } from 'react';
import { CircularProgress, MenuItem, TextField } from '@material-ui/core';
import { Publish } from '@material-ui/icons';
import { Storage } from 'aws-amplify';
import { v4 as uuidv4 } from 'uuid';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import _ from 'lodash';

import { addQuestion, updateQuestion } from '../../../services/apiService';
import awsConfig from '../../../aws-exports';

class AddOrEditQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: '',
      solution: '',
      conceptId: '',
      difficultyLevel: '',
      qsImageRef: createRef(),
      ansImageRef: createRef(),
      qsImageFile: null,
      ansImageFile: null,
    };
  }

  componentDidMount = async () => {
    try {
      if (this.props.isEditMode) {
        let concept, competency, module;
        if (this.props.ques.conceptId) {
          concept = _.find(this.props.concepts, {
            id: this.props.ques.conceptId,
          });
          competency = _.find(this.props.competencies, {
            id: concept.competencyId,
          });
          module = _.find(this.props.modules, { id: competency.moduleId });
        }
        this.setState({
          ...this.state,
          ...this.props.ques,
          ...(this.props.ques.conceptId && {
            competencyId: competency.id,
            moduleId: module.id,
          }),
        });
      }
    } catch (err) {
      console.error(err);
      this.setState({
        errorMessage: 'Failed to load question levels',
      });
    }
  };

  uploadFile = async (file, path) => {
    // upload file
    const { key } = await Storage.put(
      `questionBuilder/${path}/${uuidv4()}.${file.type.split('/')[1]}`,
      file,
      {
        contentType: file.type,
      }
    );
    if (key)
      return `https://${awsConfig.Storage.AWSS3.bucket}.s3.${awsConfig.Storage.AWSS3.region}.amazonaws.com/public/${key}`;
    else return null;
  };

  handleSubmit = async (e) => {
    try {
      e.preventDefault();
      this.setState({ loading: true });

      const payload = {
        id: this.state.id,
        question: this.state.question,
        solution: this.state.solution,
        conceptId: this.state.conceptId,
        difficultyLevel: this.state.difficultyLevel,
      };

      if (this.state.qsImageFile) {
        const qImgUrl = await this.uploadFile(
          this.state.qsImageFile,
          'questionImage'
        );
        if (!qImgUrl) {
          this.setState({
            errorMessage: 'Question Image Upload Failed!',
            loading: false,
          });
          return;
        }
        payload.questionImageUrl = qImgUrl;
      }
      if (this.state.ansImageFile) {
        const aImgUrl = await this.uploadFile(
          this.state.ansImageFile,
          'answerImage'
        );
        if (!aImgUrl) {
          this.setState({
            errorMessage: 'Answer Image Upload Failed!',
            loading: false,
          });
          return;
        }
        payload.solutionImageUrl = aImgUrl;
      }
      if (this.props.isEditMode) {
        await updateQuestion(payload);
        toast.info('Question Updated Successfully');
        this.props.goBack();
      } else await addQuestion(payload);
      this.setState({
        message: 'Question Added Successfully',
        loading: false,
        question: '',
        solution: '',
        conceptId: '',
        competencyId: '',
        moduleId: '',
        difficultyLevel: '',
        qsImageFile: '',
        ansImageFile: '',
        errorMessage: null,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        errorMessage: 'Saving Question Failed! \n Please Try Again!!',
        loading: false,
      });
    }
  };

  render() {
    const modules = this.props.modules;
    const competencies = this.props.competencies.filter(
      (cmp) => cmp.moduleId === this.state.moduleId
    );
    const concepts = this.props.concepts.filter(
      (cpt) => cpt.competencyId === this.state.competencyId
    );
    return (
      <div className='bg-white p-6 pt-8'>
        <form onSubmit={this.handleSubmit} onReset={this.props.goBack}>
          {/* Question Section Starts Here */}
          <TextField
            onChange={(e) => this.setState({ question: e.target.value })}
            value={this.state.question}
            label='Question'
            variant='outlined'
            size='small'
            multiline
            minRows={3}
            autoFocus
            fullWidth
            required
          />
          <div className='my-4' />

          {this.state.questionImageUrl && (
            <img
              src={this.state.questionImageUrl}
              onClick={() => window.open(this.state.questionImageUrl, '_blank')}
              className='max-h-64 cursor-pointer'
            />
          )}
          <label className='text-gray-400 text-xs ml-2'>Question Image</label>
          <br />
          <button
            type='button'
            onClick={() => this.state.qsImageRef.current.click()}
            className='my-2 border-2 border-gray-200 bg-gray-100 text-black rounded px-8 py-2 flex items-center gap-2'
          >
            <Publish className='opacity-60 -ml-2' />
            <span>Upload / Select File</span>
          </button>
          <input
            onChange={(e) =>
              this.setState({
                qsImageFile: e.target.files[0],
                questionImageUrl:
                  e.target.files[0] && URL.createObjectURL(e.target.files[0]),
              })
            }
            type='file'
            ref={this.state.qsImageRef}
            hidden={true}
            accept='.jpg,.jpeg,.png'
          />
          <span className='ml-4 text-green-c2'>
            {this.state?.qsImageFile?.name}
          </span>
          <br />
          <br />

          {/* Answer Section starts */}
          <TextField
            onChange={(e) => this.setState({ solution: e.target.value })}
            value={this.state.solution}
            label='Answer'
            variant='outlined'
            size='small'
            multiline
            minRows={3}
            fullWidth
            required
          />
          <div className='my-4' />

          {this.state.solutionImageUrl && (
            <img
              src={this.state.solutionImageUrl}
              onClick={() => window.open(this.state.solutionImageUrl, '_blank')}
              className='max-h-64 cursor-pointer'
            />
          )}
          <label className='text-gray-400 text-xs ml-2'>Answer Image</label>
          <br />
          <button
            type='button'
            onClick={() => this.state.ansImageRef.current.click()}
            className='my-2 border-2 border-gray-200 bg-gray-100 text-black rounded px-8 py-2 flex items-center gap-2'
          >
            <Publish className='opacity-60 -ml-2' />
            <span>Upload / Select File</span>
          </button>
          <span className='ml-4 text-green-c2'>
            {this.state?.ansImageFile?.name}
          </span>
          <br />
          <input
            onChange={(e) =>
              this.setState({
                ansImageFile: e.target.files[0],
                solutionImageUrl:
                  e.target.files[0] && URL.createObjectURL(e.target.files[0]),
              })
            }
            type='file'
            ref={this.state.ansImageRef}
            hidden={true}
            accept='.jpg,.jpeg,.png'
          />

          <div className='my-8 flex gap-4'>
            <TextField
              select
              onChange={(e) => this.setState({ moduleId: e.target.value })}
              value={this.state.moduleId || ''}
              label='Module (L1)'
              variant='outlined'
              size='small'
              fullWidth
              required
            >
              {modules.map((mdl) => (
                <MenuItem value={mdl.id} key={mdl.id}>
                  {mdl.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              disabled={!this.state.moduleId}
              onChange={(e) => this.setState({ competencyId: e.target.value })}
              value={this.state.competencyId || ''}
              label='Competency (L2)'
              variant='outlined'
              size='small'
              fullWidth
              required
            >
              {competencies.map((cmp) => (
                <MenuItem value={cmp.id} key={cmp.id}>
                  {cmp.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              disabled={!this.state.competencyId}
              onChange={(e) => this.setState({ conceptId: e.target.value })}
              value={this.state.conceptId || ''}
              label='Concept (L3)'
              variant='outlined'
              size='small'
              fullWidth
              required
            >
              {concepts.map((cpt) => (
                <MenuItem value={cpt.id} key={cpt.id}>
                  {cpt.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              onChange={(e) =>
                this.setState({ difficultyLevel: e.target.value })
              }
              value={this.state.difficultyLevel}
              label='Difficulty Level'
              variant='outlined'
              size='small'
              fullWidth
              required
            >
              <MenuItem value='easy'>Easy</MenuItem>
              <MenuItem value='medium'>Medium</MenuItem>
              <MenuItem value='hard'>Hard</MenuItem>
            </TextField>
          </div>

          <button
            type='submit'
            className='mt-4 w-64 py-2 text-white bg-blue-500 rounded'
            disabled={this.state.loading}
          >
            {this.state.loading ? (
              <CircularProgress
                size='1.5rem'
                color='inherit'
                className='-my-1.5'
              />
            ) : (
              <span>Save Question</span>
            )}
          </button>

          {this.props.isEditMode && (
            <button type='reset' className='w-36 opacity-50 font-medium'>
              Go Back
            </button>
          )}
        </form>

        {this.state.message && (
          <div className='text-blue-500 mt-4'>{this.state.message}</div>
        )}
        {this.state.errorMessage && (
          <div className='text-red-500 mt-4 whitespace-pre-line'>
            {this.state.errorMessage}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ questionLevelsReducer }) => ({
  modules: questionLevelsReducer.modules,
  competencies: questionLevelsReducer.competencies,
  concepts: questionLevelsReducer.concepts,
});

export default connect(mapStateToProps)(AddOrEditQuestion);
